export enum PassCodeSubmissionStatusEnum {
  INITIATE = "INITIATE",
  DONE = "DONE",
  ERROR = "ERROR",
  PROCESSING = "PROCESSING",
}

export enum EnvAuthenticatorStatusEnum {
  INITIAL = "INITIAL",
  PENDING = "PENDING",
  VERIFIED = "VERIFIED",
  ERROR = "ERROR",
  PROCESSING = "PROCESSING",
}

export enum AppTypeEnum {
  ENV_APP = "envapp",
  APP = "app",
}
